export const TIME_FORMATS = {
  "HH:mm:ss.uu": "HH:MI:SS.FF2",
  t: "HH12:MI AM",
  T: "HH:MI",
  TT: "HH:MI:SS",
  tt: "HH12:MI:SS AM",
};

export const MYSQL_TIME_FORMATS = {
  "HH:mm:ss.uu": "%H:%i:%s.%f",
  t: "%h:%i %p",
  T: "%H:%i",
  TT: "%H:%i:%s",
  tt: "%h:%i:%s %p",
};
